(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    const gallerythumbnails = document.querySelectorAll(
      "[data-gallerythumbnail]"
    );

    for (const gallerythumbnail of gallerythumbnails) {
      updateGallerythumbnail(gallerythumbnail);
    }
  }

  function updateGallerythumbnail(gallerythumbnail) {
    while (gallerythumbnail.hasChildNodes()) {
      gallerythumbnail.removeChild(gallerythumbnail.lastChild);
    }

    const mediaWrapper = gallerythumbnail.parentElement;
    const mediaGallery = mediaWrapper.querySelector("media-gallery");
    const mediaItems = mediaGallery.querySelectorAll(
      ".variant-slide.product__media-item.is-active"
    );

    for (const item of mediaItems) {
      const itemImage = item.querySelector("img");
      const button = document.createElement("button");
      button.classList.add("gallerythumbnail--button");
      button.type = "button";
      button.addEventListener(
        "click",
        scrollItemIntoView.bind(null, mediaGallery, item, gallerythumbnail)
      );

      const image = document.createElement("img");
      image.classList.add("gallerythumbnail--button-image");
      image.src = itemImage.src.replace(/width=[0-9]+/, "width=100");

      button.append(image);
      gallerythumbnail.append(button);
    }

    if (gallerythumbnail.children.length > 0) {
      gallerythumbnail.children[0].setAttribute("data-selected", "");
    }
  }

  window.updateGallerythumbnail = updateGallerythumbnail;

  function scrollItemIntoView(mediaGallery, item, gallerythumbnail, event) {
    for (const button of gallerythumbnail.children) {
      button.removeAttribute("data-selected");
    }

    const button = event.currentTarget;
    button.setAttribute("data-selected", "");
    mediaGallery.scrollTo({
      top: item.offsetTop,
      behavior: "smooth",
    });

    if (gallerythumbnail.children.length > 1) {
      if (button === gallerythumbnail.children[0]) {
        window.scrollTo({
          top: mediaGallery.offsetTop,
          behavior: "smooth",
        });
      } else if (
        button ===
        gallerythumbnail.children[gallerythumbnail.children.length - 1]
      ) {
        window.scrollTo({
          top:
            mediaGallery.offsetTop +
            mediaGallery.offsetHeight -
            window.innerHeight,
          behavior: "smooth",
        });
      }
    }
  }
})();
